import React from "react"

import classNames from "classnames"

import { Chip, ChipVariant } from "shared/ui/chip/Chip"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import { LoadingTags } from "./LoadingTags"
import "./styles/_tags.scss"

export interface Tag {
  key: string
  title: string
  icon?: IconName
}

export interface TagsProps {
  tags?: Tag[]
  chipStyle?: ChipVariant
  className?: string
  loadingTagAmount?: number
  isLoading?: boolean
}

export const Tags = React.memo(
  ({ tags, chipStyle, className, loadingTagAmount, isLoading }: TagsProps) => {
    if (isLoading) {
      return (
        <LoadingTags amount={loadingTagAmount} chipStyle={ChipVariant.TAG} />
      )
    }
    return tags ? (
      <div className={classNames("tags", className)}>
        {tags.map(({ title, icon, key }) => (
          <Chip key={key} variant={chipStyle || ChipVariant.TAG} icon={icon}>
            {title}
          </Chip>
        ))}
      </div>
    ) : null
  }
)
